import "./src/css/style.css";

// Load Merriweather typeface
require("typeface-merriweather");
